<template>
  <b-container fluid>
    <b-row>
      <b-col xs="12" md="12" lg="12" xl="12" class="px-0">
        <h5 class="mb-0">{{ $t("Контрагент хисоботи")}}</h5>
      </b-col>
      <div class="my-1 column3">
        <label for="">Вақт 1</label>
        <input class="form-control" type="date" v-model="datas.date1" />
      </div>
      <div class="my-1 column3">
        <label for="">Вақт 2</label>
        <input class="form-control" type="date" v-model="datas.date2" />
      </div>
      <div class="my-1 column3">
        <label>Склад</label>
        <v-select
          class="form-control-sm md-input"
          :options="skladlist"
          :disabled="skladhave"
          v-model="datas.sklad_id"
          :reduce="(name) => name.id"
          :clearable="false"
          label="name"
        >
          <template #search="{ attributes, events }">
            <input
              class="vs__search"
              v-bind="attributes"
              v-on="events"
              aria-activedescendant="null"
            />
          </template>
          <template v-slot:no-options="{ search, searching }">
            <template v-if="searching">
              <em
                ><b>{{ search }}</b></em
              >
              {{ $t("бўйича маьлумот йўқ") }}
            </template>
            <em style="opacity: 0.5" v-else>{{ $t("Маьлумот йўқ") }}</em>
          </template>
        </v-select>
      </div>
      <div class="my-1 column3">
        <label for="">Группа</label>
        <v-select
          :clearable="true"
          class="form-control-sm"
          :options="kontragentlist"
          v-model="datas.kontragent_id"
          :reduce="(name) => name.id"
          label="name"
        >
          <template #open-indicator="{ attributes }">
            <span v-bind="attributes"></span>
            <a
              href="javascript:void(0)"
              class="modallist"
              v-b-modal.modal-kontragentlist
            >
              <b-icon icon="three-dots"></b-icon>
            </a>
          </template>
          <template v-slot:no-options="{ search, searching }">
            <template v-if="searching">
              <em
                ><b>{{ search }}</b></em
              >
              бўйича маьлумот йўқ
              <button
                type="button"
                @click="kontragent.name = search"
                v-b-modal.modal-kontragent
              >
                +
              </button>
            </template>
            <em style="opacity: 0.5" v-else>Маьлумот йўқ</em>
          </template>
        </v-select>
      </div>
      <!-- <div class="my-1 column2-5">
        <label for="">{{$t('Тип оплата')}}</label>
        <v-select
          :clearable="false"
          class="form-control-sm"
          :options="pricelist"
          v-model="datas.price_type"
          :reduce="name => name.id"
          label="name"
        >
        </v-select>
      </div> -->
      <div class="my-1">
        <br /><button type="button" class="btn mybtn" @click="Send()">
          Кўриш
        </button>
        <button type="button" class="btn mybtn" @click="Print()">
          <b-icon icon="printer"></b-icon>
        </button>
        <button type="button" class="btn mybtn" @click="downloadExl">
          <b-icon icon="cloud-download"></b-icon> {{ $t("Excel(Юклаш)") }}
        </button>
        <router-link target="_blank" class="mybtn btn" :to="{ path: '/xisobot/xisobot/kontragentpos' }" >
          <b-icon icon="journal-check"></b-icon>{{$t('Қарздорлик')}}
        </router-link>
      </div>
      <div class="limiter" id="tableId">
        <md-card>
          <md-card-content>
        <table class="table table-bordered" style="font-size: 13px;">
          <thead class="thead-light">
            <tr>
              <th class="column0" rowspan="3">#</th>
              <th class="column3-5" rowspan="3">{{ $t("Номи") }}</th>
              <th class="column4" colspan="4">{{ $t("Бош. қолдиқ") }}</th>
              <th class="column2" rowspan="2" colspan="2">Доллар</th>
              <th class="column2" rowspan="2" colspan="2">Cўм</th>
              <th  class="column4" colspan="4">{{ $t("Якуний қолдиқ") }}</th>
            </tr>
            <tr>
              <th class="column2" colspan="2">Доллар</th>
              <th class="column2" colspan="2">Сўм</th>
              <th class="column2" colspan="2">Доллар</th>
              <th class="column2" colspan="2">Сўм</th>
            </tr>
            <tr>
              <th class="column1 dollar">Хаққи</th>
              <th class="column1 dollar">Қарзи</th>
              <th class="column1 dollar">Хаққи</th>
              <th class="column1 dollar">Қарзи</th>
              <th class="column1 dollar">{{ $t("Кирим") }}</th>
              <th class="column1 dollar">{{ $t("Расход") }}</th>
              <th class="column1 dollar">{{ $t("Кирим") }}</th>
              <th class="column1 dollar">{{ $t("Расход") }}</th>
              <th class="column1 dollar">Хаққи</th>
              <th class="column1 dollar">Қарзи</th>
              <th class="column1 dollar">Хаққи</th>
              <th class="column1 dollar">Қарзи</th>
            </tr>
          </thead>
          <tbody>
            <tr
              class="row100 body"
              v-for="(item, index) in results"
              :key="index"
              @click="RouteSverka(item.id)"
              style="cursor: pointer"
            >
              <td class="column0">
                {{ index + 1 }}
              </td>
              <td class="column3-5">
                {{ item.name }}
              </td>
              <td class="column1 kol dollar">
                <span v-if="item.begin_total_dollar > 0">
                  <span v-if="item.begin_total_dollar != 0">
                    {{ item.begin_total_dollar | numFormats }}
                  </span>
                </span>
              </td>
              <td class="column1 kol dollar">
                <span v-if="item.begin_total_dollar < 0">
                  <span v-if="item.begin_total_dollar != 0">
                    {{ (item.begin_total_dollar * -1) | numFormats }}
                  </span>
                </span>
              </td>
              <td class="column1 kol">
                <span v-if="item.begin_total > 0">
                  <span v-if="item.begin_total != 0">
                    {{ item.begin_total | numFormats }}
                  </span>
                </span>
              </td>
              <td class="column1 kol">
                <span v-if="item.begin_total < 0">
                  <span v-if="item.begin_total != 0">
                    {{ (item.begin_total * -1) | numFormats }}
                  </span>
                </span>
              </td>
              <td class="column1 kol dollar">
                <span :class="{ red: item.total_kirim_dollar < 0 }">
                  <span v-if="item.total_kirim_dollar != 0">
                    {{ item.total_kirim_dollar | numFormats }}
                  </span>
                </span>
              </td>
              <td class="column1 kol dollar">
                <span :class="{ red: item.total_chiqim_dollar < 0 }">
                  <span v-if="item.total_chiqim_dollar != 0">
                    {{ item.total_chiqim_dollar | numFormats }}
                  </span>
                </span>
              </td>
              <td class="column1 kol">
                <span :class="{ red: item.total_kirim < 0 }">
                  <span v-if="item.total_kirim != 0">
                    {{ item.total_kirim | numFormats }}
                  </span>
                </span>
              </td>
              <td class="column1 kol">
                <span :class="{ red: item.total_chiqim < 0 }">
                  <span v-if="item.total_chiqim != 0">
                    {{ item.total_chiqim | numFormats }}
                  </span>
                </span>
              </td>
              <td class="column1 kol dollar">
                <span v-if="item.end_total_dollar > 0">
                  <span v-if="item.end_total_dollar != 0">
                    {{ item.end_total_dollar | numFormats }}
                  </span>
                </span>
              </td>
              <td class="column1 kol dollar">
                <span v-if="item.end_total_dollar < 0">
                  <span v-if="item.end_total_dollar != 0">
                    {{ (item.end_total_dollar * -1) | numFormats }}
                  </span>
                </span>
              </td>
              <td class="column1 kol">
                <span v-if="item.end_total > 0">
                  <span v-if="item.end_total != 0">
                    {{ item.end_total | numFormats }}
                  </span>
                </span>
              </td>
              <td class="column1 kol">
                <span v-if="item.end_total < 0">
                  <span v-if="item.end_total != 0">
                    {{ (item.end_total * -1) | numFormats }}
                  </span>
                </span>
              </td>
            </tr>
          </tbody>
          <thead class="summatable1">
            <tr>
              <td style="width: 20%;" colspan="2">{{ $t("Жами") }}</td>
              <td class="column1 kol dollar">
                <span v-if="bosh_summ_dollar != 0">
                  {{ bosh_summ_dollar | numFormats }}
                </span>
              </td>
              <td class="column1 kol dollar">
                <span v-if="bosh_summ_dollar_qarz != 0">
                  {{ bosh_summ_dollar_qarz | numFormats }}
                </span>
              </td>
              <td class="column1 kol">
                <span v-if="bosh_summ != 0"> {{ bosh_summ | numFormats }}</span>
              </td>
              <td class="column1 kol">
                <span v-if="bosh_summ_qarz != 0">
                  {{ bosh_summ_qarz | numFormats }}</span
                >
              </td>
              <td class="column1 kol dollar">
                <span
                  :class="{ red: kirim_summ_dollar < 0 }"
                  v-if="kirim_summ_dollar != 0"
                  >{{ kirim_summ_dollar | numFormats }}</span
                >
              </td>
              <td class="column1 kol dollar">
                <span
                  :class="{ red: chiqim_summ_dollar < 0 }"
                  v-if="chiqim_summ_dollar != 0"
                  >{{ chiqim_summ_dollar | numFormats }}</span
                >
              </td>
              <td class="column1 kol">
                <span :class="{ red: kirim_summ < 0 }" v-if="kirim_summ != 0">{{
                  kirim_summ | numFormats
                }}</span>
              </td>
              <td class="column1 kol">
                <span
                  :class="{ red: chiqim_summ < 0 }"
                  v-if="chiqim_summ != 0"
                  >{{ chiqim_summ | numFormats }}</span
                >
              </td>
              <td class="column1 dollar kol">
                <span v-if="summ_dollar > 0">
                  <span v-if="summ_dollar != 0">
                    {{ summ_dollar | numFormats }}
                  </span>
                </span>
              </td>
              <td class="column1 dollar kol">
                <span v-if="summ_dollar_qarz != 0">
                  {{ summ_dollar_qarz | numFormats }}
                </span>
              </td>
              <td class="column1 kol">
                <span v-if="summ > 0">
                  <span v-if="summ != 0">
                    {{ summ | numFormats }}
                  </span>
                </span>
              </td>
              <td class="column1 kol">
                <span v-if="summ_qarz != 0">
                  {{ summ_qarz | numFormats }}
                </span>
              </td>
            </tr>
          </thead>
        </table>
        </md-card-content>
        </md-card>
      </div>
    </b-row>
    <kontragent :datas="datas"></kontragent>
    <sklad :datas="datas"></sklad>
    <unit></unit>
    <model></model>
    <brand></brand>
    <colour></colour>
  </b-container>
</template>

<script>
var XLSX = require("xlsx");
var FileSaver = require("file-saver");
import { print } from "../../../components/mixins/print.js";
import { Kontragent, Unit, Model, Brand, Colour, Sklad } from "@/pages";
export default {
  components: { Kontragent, Unit, Model, Brand, Colour, Sklad },
  mixins: [print],
  data() {
    return {
      datas: {
        date1: new Date().toISOString().slice(0, 8) + "01",
        date2: new Date().toISOString().slice(0, 10),
        kontragent_id: null,
        price_type: "dollar",
        sklad_id: parseInt(localStorage.getItem("sklad_id")),
      },
      summ: 0,
      summ_qarz: 0,
      summ_dollar: 0,
      summ_dollar_qarz: 0,
      bosh_summ: 0,
      bosh_summ_qarz: 0,
      bosh_summ_dollar: 0,
      bosh_summ_dollar_qarz: 0,
      kirim_summ: 0,
      kirim_summ_dollar: 0,
      chiqim_summ: 0,
      chiqim_summ_dollar: 0,
      kontragent: "",
      pricelist: [
        { id: "dollar", name: "Доллар" },
        { id: "sum", name: "Cўм" },
      ],
      kontragentlist: [],
      sklad: "",
      skladlist: [],
      errors: "",
      results: [],
    };
  },
  created() {
    let self = this;
    self.$root.$on("kontragentone", function (getdata) {
      self.kontragent = getdata;
    });
    // self.$root.$on("kontragentall", function(getdata) {
    self.Kontragentlist();
    // });
    self.$root.$on("skladone", function (getdata) {
      self.sklad = getdata;
    });
    self.$root.$on("skladall", function (getdata) {
      self.skladlist = getdata;
    });
  },
  methods: {
    Kontragentlist() {
      let self = this;
      axios({
        method: "get",
        url: "api/v1/kontragent/folder-list",
      }).then(function (response) {
        self.kontragentlist = response.data;
      });
    },
    downloadExl() {
      this.$store.state.xls=true;
      setTimeout(() => {
        let wb = XLSX.utils.table_to_book(document.getElementById("tableId")),
        wopts = {
          bookType: "xlsx",
          bookSST: false,
          type: "binary"
        };
        var wscols = [{ width: 5 },{ width: 25 },{ width: 7 },{ width: 7 },{ width: 11 },{ width: 11 },{ width: 7 },{ width: 7 },{ width: 11 },{ width: 11 },{ width: 7 },{ width: 7 },{ width: 11 },{ width: 11 }]; 
        wb.Sheets.Sheet1['!cols']=wscols;
        let wbout = XLSX.write(wb, wopts);       
        console.log(wb.Sheets.Sheet1['!cols']);
      FileSaver.saveAs(
        new Blob([this.s2ab(wbout)], {
          type: "application/octet-stream;charset=utf-8",
        }),
        new Date() + "kontragent_xisobot.xlsx"
      );
      setTimeout(() => {
        this.$store.state.xls=false;
      }, 2000);
      }, 2000);
     
    },
    s2ab(s) {
      if (typeof ArrayBuffer !== "undefind") {
        var buf = new ArrayBuffer(s.length);
        var view = new Uint8Array(buf);
        for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
        return buf;
      } else {
        var buf = new Array(s.length);
        for (var i = 0; i != s.length; ++i) buf[i] = s.charCodeAt(i) & 0xff;
        return buf;
      }
    },
    Clicked(id) {
      localStorage.setItem("date1", this.datas.date1);
      localStorage.setItem("date2", this.datas.date2);
      localStorage.setItem("kontragent", id);
      localStorage.setItem("sklad_id", this.datas.sklad_id);
      this.$router.push({ path: "/xisobot/sverka/kontragent" });
    },
    Send() {
      let self = this;
      var datas = {
        datetime1: parseInt(
          new Date(self.datas.date1).valueOf().toString().slice(0, 10)
        ),
        datetime2:
          parseInt(
            new Date(self.datas.date2).valueOf().toString().slice(0, 10)
          ) + 86399,
        sklad_id: self.datas.sklad_id,
        price_type: self.datas.price_type,
        kontragent_id: self.datas.kontragent_id,
      };
      axios({
        method: "post",
        url: "api/v1/report/kontragent",
        data: datas,
      }).then(function (response) {
        self.results = response.data;
        self.summ = 0;
        self.summ_dollar = 0;
        self.bosh_summ = 0;
        self.bosh_summ_dollar = 0;
        self.summ_qarz = 0;
        self.summ_dollar_qarz = 0;
        self.bosh_summ_qarz = 0;
        self.bosh_summ_dollar_qarz = 0;
        self.kirim_summ = 0;
        self.kirim_summ_dollar = 0;
        self.chiqim_summ = 0;
        self.chiqim_summ_dollar = 0;
        self.results.forEach(function (key, value) {
          if (key.end_total > 0) {
            self.summ += key.end_total;
          } else {
            self.summ_qarz += key.end_total * -1;
          }
          if (key.end_total_dollar > 0) {
            self.summ_dollar += key.end_total_dollar;
          } else {
            self.summ_dollar_qarz += key.end_total_dollar * -1;
          }
          if (key.begin_total > 0) {
            self.bosh_summ += key.begin_total;
          } else {
            self.bosh_summ_qarz += key.begin_total * -1;
          }
          if (key.begin_total_dollar > 0) {
            self.bosh_summ_dollar += key.begin_total_dollar;
          } else {
            self.bosh_summ_dollar_qarz += key.begin_total_dollar * -1;
          }
          self.kirim_summ += key.total_kirim;
          self.kirim_summ_dollar += key.total_kirim_dollar;
          self.chiqim_summ += key.total_chiqim;
          self.chiqim_summ_dollar += key.total_chiqim_dollar;
        });
      });
    },
    RouteSverka(id) {
      let SverkaWindow;
      SverkaWindow = window.open(
        "#/xisobot/sverka/kontragent/" +
          id +
          "/" +
          this.datas.sklad_id +
          "/" +
          this.datas.date1 +
          "/" +
          this.datas.date2 +
          "/" +
          this.datas.price_type,
        "_blank",
        "width=1000, height=1000"
      );
    },
  },
};
</script>
<style scoped>
.my-1 {
  padding-right: 10px !important;
}
.table100-body {
  max-height: 460px;
}
</style>
